<template>
  <!--   <div justify="space-around"> -->
  <div>
    <template v-if="this.Unknown">
      <v-icon v-bind:style="styleObject" :color="getColor()">
        mdi-battery-unknown
      </v-icon>
    </template>
    <template v-else>
      <template v-if="this.animatedSoC < 5 && this.animatedSoC >= 0">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-outline</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-outline</v-icon>
        </template>
      </template>
      <template v-if="this.animatedSoC < 15 && this.animatedSoC >= 5">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-10</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-10</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 25 && this.animatedSoC >= 15">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-20</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-20</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 35 && this.animatedSoC >= 25">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-30</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-30</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 45 && this.animatedSoC >= 35">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-40</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-40</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 55 && this.animatedSoC >= 45">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-50</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-50</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 65 && this.animatedSoC >= 55">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-60</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-60</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 75 && this.animatedSoC >= 65">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-70</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-70</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 85 && this.animatedSoC >= 75">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-80</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-80</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC < 95 && this.animatedSoC >= 85">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-90</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-90</v-icon>
        </template>
      </template>
      <template v-else-if="this.animatedSoC <= 100 && this.animatedSoC >= 95">
        <template v-if="this.Charging === true">
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery-charging-100</v-icon>
        </template>
        <template v-else>
          <v-icon v-bind:style="styleObject" :color="getColor()">mdi-battery</v-icon>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: "BatterySoC",
  props: {
    size: {
      type: Number,
      default: 38,
      required: true,
    },
    SoC: {
      type: Number,
      default: 0,
      require: true,
    },
    Charging: {
      type: Boolean,
      default: false,
      require: true,
    },
    ChargingRate: {
      type: Number,
      default: 5,
      required: true,
    },
    Unknown: {
      type: Boolean,
      default: false,
      required: false,
    },
    PrimaryColor: {
      type: Boolean,
      default: false,
      required: false,
    },
    CustomColor: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      styleObject: {
        fontSize: this.size + "px",
      },
      timer1: null,

      animatedSoC: 0,
      animatedSoCCounter: 5,
    };
  },
  methods: {
    getColor() {
      if (this.CustomColor != "") {
        return this.CustomColor;
      } else if (this.PrimaryColor === true) {
        return "primary";
      } else {
        if (this.SoC > 65 && this.SoC <= 100) {
          return "light-green";
        } else if (this.SoC > 45 && this.SoC <= 65) {
          return "yellow darken-1";
        } else if (this.SoC > 35 && this.SoC <= 45) {
          return "amber";
        } else if (this.SoC > 15 && this.SoC <= 35) {
          return "orange";
        } else if (this.SoC >= 0 && this.SoC <= 15) {
          return "red";
        }
      }
    },
    pollData() {
      this.timer1 = setInterval(() => {
        this.styleObject.fontSize = this.size + "px";
        this.animateCharging();
      }, 250);
    },
    animateCharging() {
      if (this.Charging == true) {
        this.animatedSoC = this.animatedSoCCounter;

        if (this.animatedSoC >= this.SoC) {
          this.animatedSoC = 5;
        }

        let rate = Math.abs(this.ChargingRate);

        if (rate < 4) {
          rate = 4;
        } else if (rate > 6) {
          rate = 6;
        }

        this.animatedSoCCounter += rate;

        if (this.animatedSoCCounter >= this.SoC) {
          this.animatedSoCCounter = 5;
        }
      } else {
        this.animatedSoCCounter = 5;
        this.animatedSoC = this.SoC;
      }
    },
  },
  created() {
    this.pollData();
  },
  beforeDestroy: function() {
    clearInterval(this.timer1);
  },
};
</script>

<style scoped>
.v-icon {
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
